var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDashboard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.77778C7 9.30628 7.18964 8.8541 7.52721 8.5207C7.86477 8.1873 8.32261 8 8.8 8H14.2V24H8.8C8.32261 24 7.86477 23.8127 7.52721 23.4793C7.18964 23.1459 7 22.6937 7 22.2222V9.77778ZM17.8 8H23.2C23.6774 8 24.1352 8.1873 24.4728 8.5207C24.8104 8.8541 25 9.30628 25 9.77778V14.2222H17.8V8ZM17.8 17.7778H25V22.2222C25 22.6937 24.8104 23.1459 24.4728 23.4793C24.1352 23.8127 23.6774 24 23.2 24H17.8V17.7778Z",
    stroke: "#4A5568",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.9ddb3bb91e534f153bcc82b6c697ce16.svg";
export { ForwardRef as ReactComponent };